import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIService } from '../../../../core/providers/apiservices';
import { ControlDTO } from '../../../../core/data/ControlDTO';
import { CampaignDTO } from '../data/CampaignDTO';
import { ErrorDTO } from '../../../../core/data/ErrorDTO';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CampaignProvider {
  private header = APIService.getHeader();
  itemret: any;

  constructor(public http: HttpClient, private translate: TranslateService) {}

  /**
   * GET campaigns
   */
  get (guidItem:string ,guidProducer:string, selectedAffiliate?: string, dtCreatedIni?: string, dtCreatedEnd?: string): Promise<any> {
    this.header = APIService.getHeader();
    return new Promise((resolve, reject) => {
      let url = `${APIService.API_URL}campaign?guidItem=${guidItem}&guidProducer=${guidProducer}`;
      if (selectedAffiliate) {
        url += `&affiliate=${selectedAffiliate}`;
      }
      if (dtCreatedIni) {
        url += `&dtCreatedIni=${dtCreatedIni}`;
      }
      if (dtCreatedEnd) {
        url += `&dtCreatedEnd=${dtCreatedEnd}`;
      }
      
      this.http.get(url, { headers: this.header }).subscribe({
        next: (response) => {
          var jsonData:ControlDTO = response;
          resolve(jsonData);

        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        }
      });
    });
  }

  /**
   * POST campaign
   */
  post(campaign: CampaignDTO): Promise<any> {
    this.header = APIService.getHeader();
    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'campaign';
      const requestData = JSON.stringify(campaign);
      this.http.post(url, requestData, { headers: this.header }).subscribe({
        next: (response) => {
          var jsonData = response as CampaignDTO;
          resolve(jsonData);
          
        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        }
      });
    });
  }

  /**
   * DELETE campaign by campaignId
   */
  delete(guidProducer: string, guidCampaign: string): Promise<any> {
    this.header = APIService.getHeader();
    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + `campaign?guidProducer=${guidProducer}&guid=${guidCampaign}`;
      this.http.delete(url, { headers: this.header }).subscribe({
        next: (response) => {
          var jsonData = response as CampaignDTO;
          resolve(jsonData);
          
        },
        error: (err) => {
          var errorData: ErrorDTO = err?.error;
          errorData.responseMessage = this.translate.instant(`ERROR_MESSAGES.${errorData.responseCode ?? ''}`);
          reject(errorData);
        }
      });
    });
  }
}
